import { sortBy as _sortBy, sortedUniqBy as _sortedUniqBy } from 'lodash';

export type pred = (val: any) => boolean;

export const sortAndUniqBy = <T>(arr: T[], k: string): T[] => _sortedUniqBy(_sortBy(arr, k), k);
export const sum = (a: number, b: number) => a + b;
export const difference = <T>(arr1: T[], arr2: T[]) => arr1.filter(x => !arr2.includes(x));
